import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import PermissionForm from './PermissionForm'
import { BackButton, hasPermission } from '../../sc-utilities';
import * as actions from "./store/permissionActions";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});
const PermissionEdit = props => {
    const { permission, activeCustomer, classes, loading, translations, permissions } = props;
    const [data, setData] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await props.loadPermission({ ActiveCustomerID: activeCustomer, PermissionID: parseURL(window.location.href).permissionID })
            setData(false)
        }
        fetchData();
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = data => {
        data['PermissionID'] = permission.PermissionID
        let result = props.editPermission({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    };

    let initialValues = { Name: permission.Name || "", Key: permission.Key || "", Module: permission.Module || "" };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations['edit_permission'] || "Edit permission",
        ButtonSubmit: hasPermission(permissions, "permission_save") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    // Render form
    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }} >

                <AppLogoLoading />
            </Dialog>
            {!data ?
                <PermissionForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                ></PermissionForm>
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>

    );
};
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        permission: state.admin.permission.loaded ? state.admin.permission.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadPermission: filterParams => dispatch(actions.loadPermission(filterParams)),
        editPermission: data => dispatch(actions.editPermissions(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(PermissionEdit));
